import React, { lazy, useCallback, useEffect, useState } from "react"
import { AppLayout } from "./components/app/AppLayout"
import { HomePage } from "./pages/HomePage"
import { Route, Routes } from "react-router-dom"
import { Preloader } from "./components/common/Preloader"
import { withSuspense } from "./hoc/withSuspense"
import { useAppDispatch, useAppSelector } from "./store/hooks"
import { authThunk, selectIsAuth } from "./store/authSlice"
const FAQPage = lazy(() => import("./pages/FAQPage"))
const PersonalArea = lazy(() => import("./pages/PersonalAreaPage"))
const NotFound = lazy(() => import("./pages/ErrorPages/NotFound"))
const NotAuthorized = lazy(() => import("./pages/ErrorPages/NotAuthorized"))


const App = () => {
  const [isLoading, setIsLoading] = useState(true)
  const isAuth = useAppSelector(selectIsAuth)
  const dispatch = useAppDispatch()
  
  const authorize = useCallback(async () => {
    await dispatch(authThunk.auth())
    setIsLoading(false)
  }, [dispatch])

  useEffect(() => {
    authorize()
  }, [authorize])

  if (isLoading) {
    return <Preloader/>
  }

  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<HomePage/>}/>
        <Route path="/faq" element={withSuspense(FAQPage)}/>
        {isAuth ?
          <Route path="/pa" element={withSuspense(PersonalArea)}/>
          :
          <Route path="/pa" element={withSuspense(NotAuthorized)}/>
        }            
        <Route path="*" element={withSuspense(NotFound)}/>
      </Routes>
    </AppLayout>
  );
}

export default App;
